import { react } from "react";
import HeroSection from "../components/HeroSection";
import Seo from "../components/Seo";

const Contact = () => {
    return (
        <div className="newspaper-container-wrapper">
            <Seo
                title="Contact Us"
                description="Etawah Times से संपर्क करें - खबर, विज्ञापन और सुझाव के लिए हमें लिखें।"
                canonical="/contact"
            />
            <HeroSection pageType="other" />
            <div className="container py-5">
                <div className="row justify-content-center">
                    <h3>Contact us</h3>
                    <div className="col-md-6">
                        <form>
                            <input type="email" className="form-control mb-2" name="email" placeholder="Email Address" required />
                            <textarea name="message" className="form-control mb-2" placeholder="Type your message here..." required></textarea>
                            <button type="submit" className="contact-submit-btn btn btn-small bg-primary text-white">Send Message</button>
                        </form>
                    </div>
                    <div className="col-md-6">
                    </div>
                </div>
            </div>
        </div >
    );

};

export default Contact;

